import type { VideoData, VideoParser } from './video';
import { InvalidVideo } from './videoErrors';

const isValidUrl = (url: string): boolean => {
  const regex = /(?:vimeo\.com\/(?:.*\/)?|player\.vimeo\.com\/video\/)(\d+)/;
  return regex.test(url);
};

const getContentData = async (url: string): Promise<VideoData> => {
  const metadata = await getMetadataFromVideoId(url);

  return {
    type: 'vimeo',
    title: metadata.title,
    author: metadata.author_name,
    thumbnail: metadata.thumbnail_url,
    videoId: metadata.video_id,
  };
};

const getMetadataFromVideoId = async (url: string) => {
  const apiUrl = `https://vimeo.com/api/oembed.json?url=${url}`;

  try {
    const response = await fetch(apiUrl);
    if (!response.ok) throw new InvalidVideo();

    return await response.json();
  } catch (error) {
    throw new InvalidVideo();
  }
};

export const vimeoVideo: VideoParser = {
  isValidUrl,
  getContentData,
};
